import { memo } from 'react';

import { Flex, List, Skeleton, Typography } from 'antd';

import type { Notification } from '@/entities/notification';

import {
    useNotificationDate,
    useNotificationDescription,
    useNotificationIcon,
    useNotificationTitle,
} from '../../lib/use-notification-formater';

import cls from './notification-item.module.css';

type NotificationItemProps = {
    notification: Notification;
    onOpenModal: (notification: Notification) => void;
    loading: boolean;
};

export const NotificationItem = memo<NotificationItemProps>(
    ({ notification, onOpenModal, loading }) => {
        const Icon = useNotificationIcon(notification);
        const title = useNotificationTitle(notification);
        const description = useNotificationDescription(notification);
        const formattedDate = useNotificationDate(notification);

        return (
            <List.Item
                className={`${notification.read ? cls.read : cls.unread} ${cls.listItem}`}
                onClick={() => onOpenModal(notification)}
            >
                <Skeleton
                    active
                    avatar
                    loading={loading}
                    title={false}
                >
                    <List.Item.Meta
                        avatar={Icon && <Icon />}
                        className={cls.listItemMeta}
                        description={description}
                        title={
                            <div className={cls.titleContainer}>
                                <Flex
                                    justify="space-between"
                                    style={{ width: '100%' }}
                                >
                                    <Typography.Title
                                        level={5}
                                        style={{ marginBottom: 0 }}
                                    >
                                        {title}
                                    </Typography.Title>
                                    <Typography.Text className={cls.date}>
                                        {formattedDate}
                                    </Typography.Text>
                                </Flex>
                            </div>
                        }
                    />
                </Skeleton>
            </List.Item>
        );
    },
);

NotificationItem.displayName = 'NotificationItem';
